export default __webpack_public_path__ + "static/media/todobg.a828949b.jpg";